;(function () {
  'use strict'

  angular
    .module('contrast.common')
    .controller('PasswordResetCtrl', [
      '$scope',
      '$location',
      'logger',
      'CommonFactory',
      PasswordResetCtrl
    ])

  function PasswordResetCtrl($scope, $location, logger, CommonFactory) {
    angular.extend($scope, {
      resetting: false,
      model: {
        email: ''
      }
    })

    angular.extend($scope, {
      reset: reset
    })

    function reset() {
      $scope.resetting = true
      CommonFactory.requestReset($scope.model.email).then(
        function () {
          //Don't mark resetting as false here (only when in error)
          logger.logSuccess(
            "INCOMING! We've sent further instructions to " + $scope.model.email
          )
          $location.path('/pages/signin', true)
        },
        function (response) {
          $scope.resetting = false
          var data = response.data
          logger.logError(data.messages[0])
        }
      )
    }
  }
})()
